import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function Tent({
  position = [56.84, -0.08, -7.5],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/tent.glb");
  const tentScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    tentScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [tentScene]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={tentScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/tent.glb");
